// ISO 3166-1 alpha-2 country list with English names + approximate centroid [lng, lat].
// Centroids are used to place gold checkmarks on the world map.
// Source: aggregated from Natural Earth centroids (public domain).
// Trimmed to sovereign states + widely-recognised territories; small islands omitted.

export const COUNTRIES = [
  { code: "AF", name: "Afghanistan",              coord: [66.00, 33.83] },
  { code: "AL", name: "Albania",                  coord: [20.05, 41.14] },
  { code: "DZ", name: "Algeria",                  coord: [2.63, 28.16] },
  { code: "AO", name: "Angola",                   coord: [17.54, -12.30] },
  { code: "AR", name: "Argentina",                coord: [-65.17, -35.38] },
  { code: "AM", name: "Armenia",                  coord: [44.93, 40.29] },
  { code: "AU", name: "Australia",                coord: [134.49, -25.73] },
  { code: "AT", name: "Austria",                  coord: [14.13, 47.59] },
  { code: "AZ", name: "Azerbaijan",               coord: [47.60, 40.29] },
  { code: "BS", name: "Bahamas",                  coord: [-77.31, 24.29] },
  { code: "BH", name: "Bahrain",                  coord: [50.55, 26.04] },
  { code: "BD", name: "Bangladesh",               coord: [90.24, 23.87] },
  { code: "BB", name: "Barbados",                 coord: [-59.56, 13.16] },
  { code: "BY", name: "Belarus",                  coord: [28.03, 53.54] },
  { code: "BE", name: "Belgium",                  coord: [4.66, 50.64] },
  { code: "BZ", name: "Belize",                   coord: [-88.71, 17.21] },
  { code: "BJ", name: "Benin",                    coord: [2.32, 9.64] },
  { code: "BT", name: "Bhutan",                   coord: [90.40, 27.42] },
  { code: "BO", name: "Bolivia",                  coord: [-64.68, -16.71] },
  { code: "BA", name: "Bosnia and Herzegovina",   coord: [17.79, 44.16] },
  { code: "BW", name: "Botswana",                 coord: [23.79, -22.19] },
  { code: "BR", name: "Brazil",                   coord: [-53.09, -10.79] },
  { code: "BN", name: "Brunei",                   coord: [114.55, 4.52] },
  { code: "BG", name: "Bulgaria",                 coord: [25.22, 42.75] },
  { code: "BF", name: "Burkina Faso",             coord: [-1.75, 12.27] },
  { code: "BI", name: "Burundi",                  coord: [29.86, -3.35] },
  { code: "KH", name: "Cambodia",                 coord: [104.90, 12.71] },
  { code: "CM", name: "Cameroon",                 coord: [12.74, 5.69] },
  { code: "CA", name: "Canada",                   coord: [-98.31, 61.37] },
  { code: "CV", name: "Cape Verde",               coord: [-23.62, 15.94] },
  { code: "CF", name: "Central African Republic", coord: [20.47, 6.57] },
  { code: "TD", name: "Chad",                     coord: [18.66, 15.34] },
  { code: "CL", name: "Chile",                    coord: [-71.35, -37.75] },
  { code: "CN", name: "China",                    coord: [103.82, 36.56] },
  { code: "CO", name: "Colombia",                 coord: [-73.09, 3.91] },
  { code: "KM", name: "Comoros",                  coord: [43.68, -11.88] },
  { code: "CG", name: "Congo",                    coord: [15.22, -0.84] },
  { code: "CD", name: "DR Congo",                 coord: [23.65, -2.88] },
  { code: "CR", name: "Costa Rica",               coord: [-84.19, 9.98] },
  { code: "CI", name: "Côte d'Ivoire",            coord: [-5.55, 7.63] },
  { code: "HR", name: "Croatia",                  coord: [16.40, 45.08] },
  { code: "CU", name: "Cuba",                     coord: [-79.02, 21.62] },
  { code: "CY", name: "Cyprus",                   coord: [33.22, 35.05] },
  { code: "CZ", name: "Czech Republic",           coord: [15.34, 49.80] },
  { code: "DK", name: "Denmark",                  coord: [9.32, 56.06] },
  { code: "DJ", name: "Djibouti",                 coord: [42.57, 11.75] },
  { code: "DM", name: "Dominica",                 coord: [-61.35, 15.44] },
  { code: "DO", name: "Dominican Republic",       coord: [-70.51, 18.89] },
  { code: "EC", name: "Ecuador",                  coord: [-78.42, -1.42] },
  { code: "EG", name: "Egypt",                    coord: [29.87, 26.54] },
  { code: "SV", name: "El Salvador",              coord: [-88.87, 13.74] },
  { code: "GQ", name: "Equatorial Guinea",        coord: [10.34, 1.71] },
  { code: "ER", name: "Eritrea",                  coord: [38.85, 15.38] },
  { code: "EE", name: "Estonia",                  coord: [25.87, 58.67] },
  { code: "SZ", name: "Eswatini",                 coord: [31.48, -26.56] },
  { code: "ET", name: "Ethiopia",                 coord: [39.62, 8.63] },
  { code: "FJ", name: "Fiji",                     coord: [178.07, -17.43] },
  { code: "FI", name: "Finland",                  coord: [26.28, 64.95] },
  { code: "FR", name: "France",                   coord: [2.45, 46.71] },
  { code: "GA", name: "Gabon",                    coord: [11.78, -0.60] },
  { code: "GM", name: "Gambia",                   coord: [-15.49, 13.44] },
  { code: "GE", name: "Georgia",                  coord: [43.51, 42.17] },
  { code: "DE", name: "Germany",                  coord: [10.38, 51.11] },
  { code: "GH", name: "Ghana",                    coord: [-1.22, 7.96] },
  { code: "GR", name: "Greece",                   coord: [22.95, 39.63] },
  { code: "GT", name: "Guatemala",                coord: [-90.36, 15.69] },
  { code: "GN", name: "Guinea",                   coord: [-10.94, 10.44] },
  { code: "GW", name: "Guinea-Bissau",            coord: [-14.94, 12.05] },
  { code: "GY", name: "Guyana",                   coord: [-58.98, 4.79] },
  { code: "HT", name: "Haiti",                    coord: [-72.68, 18.94] },
  { code: "HN", name: "Honduras",                 coord: [-86.62, 14.83] },
  { code: "HU", name: "Hungary",                  coord: [19.40, 47.16] },
  { code: "IS", name: "Iceland",                  coord: [-18.57, 64.98] },
  { code: "IN", name: "India",                    coord: [79.62, 22.89] },
  { code: "ID", name: "Indonesia",                coord: [117.24, -2.22] },
  { code: "IR", name: "Iran",                     coord: [54.28, 32.58] },
  { code: "IQ", name: "Iraq",                     coord: [43.68, 33.04] },
  { code: "IE", name: "Ireland",                  coord: [-8.14, 53.18] },
  { code: "IL", name: "Israel",                   coord: [34.85, 31.47] },
  { code: "IT", name: "Italy",                    coord: [12.07, 42.79] },
  { code: "JM", name: "Jamaica",                  coord: [-77.31, 18.16] },
  { code: "JP", name: "Japan",                    coord: [138.03, 37.59] },
  { code: "JO", name: "Jordan",                   coord: [36.77, 31.25] },
  { code: "KZ", name: "Kazakhstan",               coord: [67.29, 48.16] },
  { code: "KE", name: "Kenya",                    coord: [37.86, 0.53] },
  { code: "KW", name: "Kuwait",                   coord: [47.59, 29.34] },
  { code: "KG", name: "Kyrgyzstan",               coord: [74.55, 41.46] },
  { code: "LA", name: "Laos",                     coord: [103.75, 18.51] },
  { code: "LV", name: "Latvia",                   coord: [24.91, 56.86] },
  { code: "LB", name: "Lebanon",                  coord: [35.88, 33.92] },
  { code: "LS", name: "Lesotho",                  coord: [28.24, -29.58] },
  { code: "LR", name: "Liberia",                  coord: [-9.32, 6.45] },
  { code: "LY", name: "Libya",                    coord: [17.83, 27.03] },
  { code: "LT", name: "Lithuania",                coord: [23.90, 55.34] },
  { code: "LU", name: "Luxembourg",               coord: [6.09, 49.77] },
  { code: "MG", name: "Madagascar",               coord: [46.71, -19.36] },
  { code: "MW", name: "Malawi",                   coord: [34.30, -13.22] },
  { code: "MY", name: "Malaysia",                 coord: [109.68, 3.79] },
  { code: "MV", name: "Maldives",                 coord: [73.22, 3.20] },
  { code: "ML", name: "Mali",                     coord: [-3.55, 17.35] },
  { code: "MT", name: "Malta",                    coord: [14.41, 35.90] },
  { code: "MR", name: "Mauritania",               coord: [-10.34, 20.26] },
  { code: "MU", name: "Mauritius",                coord: [57.55, -20.28] },
  { code: "MX", name: "Mexico",                   coord: [-102.53, 23.94] },
  { code: "MD", name: "Moldova",                  coord: [28.46, 47.19] },
  { code: "MN", name: "Mongolia",                 coord: [103.05, 46.83] },
  { code: "ME", name: "Montenegro",               coord: [19.28, 42.79] },
  { code: "MA", name: "Morocco",                  coord: [-6.32, 31.87] },
  { code: "MZ", name: "Mozambique",               coord: [35.54, -17.27] },
  { code: "MM", name: "Myanmar",                  coord: [96.49, 21.19] },
  { code: "NA", name: "Namibia",                  coord: [17.21, -22.14] },
  { code: "NP", name: "Nepal",                    coord: [83.94, 28.25] },
  { code: "NL", name: "Netherlands",              coord: [5.28, 52.10] },
  { code: "NZ", name: "New Zealand",              coord: [171.48, -41.81] },
  { code: "NI", name: "Nicaragua",                coord: [-85.03, 12.85] },
  { code: "NE", name: "Niger",                    coord: [9.39, 17.42] },
  { code: "NG", name: "Nigeria",                  coord: [8.10, 9.60] },
  { code: "MK", name: "North Macedonia",          coord: [21.71, 41.60] },
  { code: "KP", name: "North Korea",              coord: [127.19, 40.15] },
  { code: "NO", name: "Norway",                   coord: [15.34, 64.57] },
  { code: "OM", name: "Oman",                     coord: [56.09, 20.60] },
  { code: "PK", name: "Pakistan",                 coord: [69.34, 29.97] },
  { code: "PS", name: "Palestine",                coord: [35.20, 31.94] },
  { code: "PA", name: "Panama",                   coord: [-80.11, 8.51] },
  { code: "PG", name: "Papua New Guinea",         coord: [145.19, -6.43] },
  { code: "PY", name: "Paraguay",                 coord: [-58.39, -23.24] },
  { code: "PE", name: "Peru",                     coord: [-74.38, -9.16] },
  { code: "PH", name: "Philippines",              coord: [122.85, 11.77] },
  { code: "PL", name: "Poland",                   coord: [19.39, 52.13] },
  { code: "PT", name: "Portugal",                 coord: [-8.51, 39.60] },
  { code: "QA", name: "Qatar",                    coord: [51.19, 25.32] },
  { code: "RO", name: "Romania",                  coord: [24.98, 45.84] },
  { code: "RU", name: "Russia",                   coord: [96.69, 61.99] },
  { code: "RW", name: "Rwanda",                   coord: [29.92, -1.99] },
  { code: "SA", name: "Saudi Arabia",             coord: [44.53, 24.13] },
  { code: "SN", name: "Senegal",                  coord: [-14.45, 14.36] },
  { code: "RS", name: "Serbia",                   coord: [20.79, 44.22] },
  { code: "SC", name: "Seychelles",               coord: [55.48, -4.66] },
  { code: "SL", name: "Sierra Leone",             coord: [-11.79, 8.56] },
  { code: "SG", name: "Singapore",                coord: [103.82, 1.35] },
  { code: "SK", name: "Slovakia",                 coord: [19.49, 48.71] },
  { code: "SI", name: "Slovenia",                 coord: [14.81, 46.12] },
  { code: "SB", name: "Solomon Islands",          coord: [160.15, -9.61] },
  { code: "SO", name: "Somalia",                  coord: [45.71, 4.75] },
  { code: "ZA", name: "South Africa",             coord: [25.08, -29.00] },
  { code: "KR", name: "South Korea",              coord: [127.83, 36.38] },
  { code: "SS", name: "South Sudan",              coord: [30.25, 7.31] },
  { code: "ES", name: "Spain",                    coord: [-3.65, 40.24] },
  { code: "LK", name: "Sri Lanka",                coord: [80.70, 7.61] },
  { code: "SD", name: "Sudan",                    coord: [29.94, 16.00] },
  { code: "SR", name: "Suriname",                 coord: [-55.91, 4.13] },
  { code: "SE", name: "Sweden",                   coord: [16.75, 62.78] },
  { code: "CH", name: "Switzerland",              coord: [8.14, 46.80] },
  { code: "SY", name: "Syria",                    coord: [38.51, 35.03] },
  { code: "TW", name: "Taiwan",                   coord: [120.95, 23.75] },
  { code: "TJ", name: "Tajikistan",               coord: [71.01, 38.53] },
  { code: "TZ", name: "Tanzania",                 coord: [34.81, -6.27] },
  { code: "TH", name: "Thailand",                 coord: [101.00, 15.11] },
  { code: "TL", name: "Timor-Leste",              coord: [125.87, -8.83] },
  { code: "TG", name: "Togo",                     coord: [0.98, 8.53] },
  { code: "TT", name: "Trinidad and Tobago",      coord: [-61.33, 10.45] },
  { code: "TN", name: "Tunisia",                  coord: [9.55, 34.12] },
  { code: "TR", name: "Turkey",                   coord: [35.17, 39.06] },
  { code: "TM", name: "Turkmenistan",             coord: [58.94, 39.11] },
  { code: "UG", name: "Uganda",                   coord: [32.39, 1.28] },
  { code: "UA", name: "Ukraine",                  coord: [31.39, 49.00] },
  { code: "AE", name: "United Arab Emirates",     coord: [54.20, 23.90] },
  { code: "GB", name: "United Kingdom",           coord: [-2.87, 54.12] },
  { code: "US", name: "United States",            coord: [-98.61, 39.37] },
  { code: "UY", name: "Uruguay",                  coord: [-56.02, -32.79] },
  { code: "UZ", name: "Uzbekistan",               coord: [63.13, 41.75] },
  { code: "VE", name: "Venezuela",                coord: [-66.19, 7.13] },
  { code: "VN", name: "Vietnam",                  coord: [106.30, 16.61] },
  { code: "YE", name: "Yemen",                    coord: [47.59, 15.91] },
  { code: "ZM", name: "Zambia",                   coord: [27.77, -13.46] },
  { code: "ZW", name: "Zimbabwe",                 coord: [29.85, -19.00] },
];

export const COUNTRY_BY_CODE = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));
